// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2bfcf229","404":"f174c4ca","498":"830312f3"}[chunkId] + ".chunk.js";
};